/**
 * Detects and removes duplicated paragraph blocks in HTML content.
 * Used to fix chapters generated with the old (buggy) streaming approach.
 */
export function deduplicateChapterContent(htmlContent) {
  if (!htmlContent) return ''
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlContent, 'text/html')
  const elements = Array.from(doc.body.children)

  const seen = new Set()
  const deduplicated = []

  elements.forEach(el => {
    const fingerprint = el.textContent.trim().slice(0, 80).toLowerCase().replace(/\s+/g, ' ')

    if (fingerprint.length < 10) {
      if (!seen.has(fingerprint)) {
        seen.add(fingerprint)
        deduplicated.push(el.outerHTML)
      }
      return
    }

    if (!seen.has(fingerprint)) {
      seen.add(fingerprint)
      deduplicated.push(el.outerHTML)
    }
  })

  return deduplicated.join('\n')
}

/**
 * Detects duplicate section headings and removes all but the first occurrence
 * along with the content between that heading and the next same-level heading.
 */
export function removeDuplicateSections(htmlContent) {
  if (!htmlContent) return ''
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlContent, 'text/html')
  const elements = Array.from(doc.body.children)

  const seenHeadings = new Set()
  const result = []
  let skipUntilNextHeading = false
  let skipLevel = null

  elements.forEach(el => {
    const tag = el.tagName.toLowerCase()
    const isHeading = ['h1', 'h2', 'h3', 'h4'].includes(tag)

    if (isHeading) {
      const headingText = el.textContent.trim().toLowerCase()

      if (skipUntilNextHeading && tag <= skipLevel) {
        skipUntilNextHeading = false
        skipLevel = null
      }

      if (seenHeadings.has(headingText)) {
        skipUntilNextHeading = true
        skipLevel = tag
        return
      }

      seenHeadings.add(headingText)
    }

    if (!skipUntilNextHeading) {
      result.push(el.outerHTML)
    }
  })

  return result.join('\n')
}
